import { motion } from "framer-motion";
import { HYDROGEN_LOOP_STAGES, EMS_FUNCTIONS } from "@/data/content";

export const HydrogenAndEnergyManagement = () => (
  <section
    data-testid="hydrogen-energy-management-section"
    className="bg-baseLight px-6 py-[30px] sm:py-[32px] lg:px-12 lg:py-[56px]"
  >
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl lg:max-w-none lg:text-center"
      >
        <h2
          data-testid="hydrogen-energy-management-headline"
          className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:whitespace-nowrap lg:text-[36px]"
        >
          How the system stores and manages energy
        </h2>
      </motion.div>

      <div className="relative mt-10 grid grid-cols-1 divide-y divide-borderLight border-t border-borderLight sm:grid-cols-2 sm:divide-x sm:divide-y-0 lg:mt-12 lg:items-start lg:divide-x-0">
        <span
          aria-hidden="true"
          className="hidden lg:absolute lg:left-1/2 lg:top-0 lg:block lg:h-[92%] lg:w-px lg:-translate-x-1/2 lg:bg-borderLight"
        />
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.55 }}
          data-testid="hydrogen-storage-column"
          className="py-8 sm:pr-10 sm:py-10 lg:pr-12"
        >
          <span className="text-xs font-medium uppercase tracking-[0.1em] text-inkMuted">
            Hydrogen Storage
          </span>
          <p className="mt-[32px] lg:mt-3 w-[calc(100%+10px)] -ml-[5px] sm:w-auto sm:ml-0 text-[15px] leading-relaxed text-inkSoft">
            When renewable generation exceeds immediate farm demand, surplus electricity can
            be converted into hydrogen through a reversible process, stored for later use and
            converted back into electricity when conditions or load require it.
          </p>
          <div className="mt-5 space-y-3 border-t border-borderLight pt-5">
            {HYDROGEN_LOOP_STAGES.map((stage) => (
              <div key={stage.title} className="flex gap-3 text-sm leading-relaxed">
                <span className="font-medium text-ink shrink-0">{stage.title}</span>
                <span className="text-inkMuted">—</span>
                <span className="text-inkSoft">{stage.body}</span>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.55, delay: 0.08 }}
          data-testid="energy-management-column"
          className="pt-8 pb-[12px] sm:py-10 sm:pl-10 lg:pl-12"
        >
          <span className="text-xs font-medium uppercase tracking-[0.1em] text-inkMuted">
            Energy Management
          </span>
          <p className="mt-[32px] lg:mt-3 text-[15px] leading-relaxed text-inkSoft">
            Energy management coordinates generation, battery response, hydrogen storage and
            farm demand so that available renewable electricity can be used, balanced or
            stored according to operating requirements.
          </p>
          <div className="mt-5 space-y-3 border-t border-borderLight pt-5">
            {EMS_FUNCTIONS.map((fn) => (
              <div key={fn.title} className="flex gap-3 text-sm leading-relaxed">
                <span className="font-medium text-ink shrink-0">{fn.title}</span>
                <span className="text-inkMuted">—</span>
                <span className="text-inkSoft">{fn.body}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
